<script setup>
  import { ref, watch, onMounted, getCurrentInstance } from 'vue'
  import { useUserStore } from '../../stores/user'
  import { usePageLoadingStore } from '../../../../stores/pageLoading';
  import { useNavigationStore } from '../../../../stores/navigation';
  import { useRouter, useRoute } from 'vue-router'
  import { storeToRefs } from 'pinia'
  import JobFairCorpInfoDetailModal from "@/pages/user/components/modal/jobFair/JobFairCorpInfoDetailModal.vue";
  import mypageJobFairService from '../../services/mypage/jobFair/mypageJobFairService';
  import KSATextButtonStop from '../../../../components/ui-components/button/KSATextButtonStop.vue';
  import JobFairReusmeCreatePolicyModal from '../../components/modal/jobFair/JobFairReusmeCreatePolicyModal.vue';

  const navigationStore = useNavigationStore();
  const loadingStore = usePageLoadingStore();
  const userStore = useUserStore();
  const { user, isAuthenticated } = storeToRefs(userStore);

  const router = useRouter();
  const route = useRoute();

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { alert, confirm, $pageListBoardNo } = globals;

  const industryGbOptions = ref(globals.$industryGb || []);
  const corpGbOptions = ref(globals.$corpGb || []);
  const corpPublicYnOptions = ref(globals.$corpPublicYn || []);

  const searchOpen = ref(true);

  const industryGbListRef = ref(null);
  const corpGbListRef = ref(null);
  const corpPublicYnListRef = ref(null);
  const workAreaCorpRef = ref(null);

  const corpInfoModal = ref(null); // 기업정보
  const jobFairReusmeCreatePolicyModal = ref(null);

  let userCorpMasterYn = ref('N'); // 기업마스터유무
  let userCorpId = ref(''); // 기업아이디
  const isStudent = ref(false);

  const onSelectedCorpArea1Option = (option) => {
    searchInput.value.workArea1 = option === '시/도 선택' ? '' : option;
  };

  const onSelectedCorpArea2Option = (option) => {
    searchInput.value.workArea2 = option === '시/구/군 선택' ? '' : option;
  };

  const initialSearchInput = {
    industryGbs: industryGbOptions.value.map(item => item.value),
    corpGbs: corpGbOptions.value.map(item => item.value),
    corpPublicYns: corpPublicYnOptions.value.map(item => item.value),
    bizType: '',
    workArea1: '',
    workArea2: '',
  };
  const searchInput = ref({ ...initialSearchInput });

  const clearSearch = () => {
    Object.assign(searchInput.value, initialSearchInput);

    if (industryGbListRef.value && industryGbListRef.value.initOptions) {
      industryGbListRef.value.initOptions();
    }
    if (corpGbListRef.value && corpGbListRef.value.initOptions) {
      corpGbListRef.value.initOptions();
    }
    if (corpPublicYnListRef.value && corpPublicYnListRef.value.initOptions) {
      corpPublicYnListRef.value.initOptions();
    }
    if (workAreaCorpRef.value && workAreaCorpRef.value.initSelectedOption) {
      workAreaCorpRef.value.initSelectedOption('', '');
    }
  };

  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  };

  const currentPage = ref(1);
  const pageSize = ref(20);
  const totalPages = ref(0);
  const totalCount = ref(0);
  const list = ref([]);

  const corporation = ref(null);

  const jobOrderByList = [
    { label: '최근 등록순', value: 'createDate DESC'},
    { label: '최근 수정순', value: 'modifyDate DESC'},
  ];

  const pageSizeGroup = ref([
    { label:"20개씩 보기", value: "20" },
    { label:"40개씩 보기", value: "40" },
    { label:"60개씩 보기", value: "60" },
    { label:"80개씩 보기", value: "80" },
    { label:"100개씩 보기", value: "100" },
  ]);

  const retrieveList = () => {
    const params = {
      searchIndustryGbs: searchInput?.value.industryGbs?.join(',') || "",
      searchCorpGbs: searchInput?.value.corpGbs?.join(',') || "",
      searchCorpPublicYn: searchInput?.value.corpPublicYns?.join(',') || "",
      searchBizType: searchInput?.value.bizType || "",
      searchResidences: `${searchInput?.value.workArea1 || ''}${searchInput?.value.workArea1 ? ' ' : ''}${searchInput?.value.workArea2 || ''}`,
      pageNumber: currentPage.value,
      size: pageSize.value,
      userId: user.value?.userId || '',
      corpId: '',
      orderProperty: searchInput.value.orderProperty,
      orderDirection: searchInput.value.orderDirection,
    };

    loadingStore.loading = true;
    mypageJobFairService.retrieveAllCorpPaging(params)
      .then(res => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
        loadingStore.loading = false;
      })
      .catch( (error) =>  {
        loadingStore.loading = false;
      });
  };

  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  };

  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  };

  // 정렬 셀렉트 박스 선택
  const onSelectOrderBy = (option) => {
    loadingStore.loading = true;
    const [orderProperty, orderDirection] = option.value.split(" ");
    currentPage.value = 1;
    searchInput.value.orderProperty = orderProperty;
    searchInput.value.orderDirection = orderDirection;
    retrieveList();
  };

  const onClickEntryCorpInfo = async () => {
    if(!isAuthenticated.value) {
      // 로그인 X
      alert("로그인 후 이용해주세요.");
      navigationStore.lastAccessPage = route.fullPath;
      router.push({name: 'Signin'});
    } else {
      if ((user.value.userGb === 'COMPANY' && userCorpMasterYn.value === 'Y')) {
        // 기업 채용공고 등록 시 기업정보 등록 및 정보제공동의여부 확인
        mypageJobFairService.retrieveRecruitPrivacyAgreeYnByCorpId(corporation.value.corpId)
          .then( async (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;

              if (result !== 'Y') {  // 기업정보 및 정보제공동의여부 내역 없을 때
                router.push({ name: 'MyPageCorpInfoCreate' });
              } else {
                const ok = await confirm(["등록된 기업정보가 있습니다."], "기업정보 관리", "확인");
                if (ok) {
                  router.push({ name: 'MyPageCorpJobFair' });
                }
              }
            }
          })
          .catch( (error) =>  {
            loadingStore.loading = false;
          });
      } else {
        alert(["재직자/기업 마스터 회원만", "기업정보 등록이 가능합니다."]);
      }
    }
  }

  // 관심 기업 관심여부 변경
  const onClickInterestCorp = async (item) => {
    const inteYn = item.interestYn === 'Y' ? 'N' : 'Y';

    const ok = await confirm([`관심기업으로 ${inteYn === 'Y' ? '등록' : '삭제'}하시겠습니까?`], `관심기업 ${inteYn === 'Y' ? '등록' : '삭제'}`, "취소");
    if (ok) {
      const paramObj = {
        corpId: item.corpId,
        userId: user.value?.userId || '',
        interestYn: inteYn,
      }
      item.interestYn = inteYn;

      mypageJobFairService.updateInterestHallEntryYn(paramObj)
        .then( (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            alert(`${inteYn === 'Y' ? '등록' : '삭제'}하였습니다.`);
          } else {
            alert("실패하였습니다.");
          }
        })
        .catch( (res) =>  {
          alert("실패하였습니다.");
        });
    }
  }

  // 기업정보 조회
  const retrieveCorporation = async () => {
    mypageJobFairService.retrieveCorporation(user.value.userInfo?.corporation?.corpId)
      .then(res => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          corporation.value = result;
        }
      })
      .catch( (error) =>  {
      });
  };

  // 기업정보 보기
  const onClickCorp = async (corp) => {
    if(!isAuthenticated.value) {
      // 로그인 X
      alert("로그인 후 이용해주세요.");
      navigationStore.lastAccessPage = route.fullPath;
      router.push({name: 'Signin'});
      return;
    } 

    const result = await corpInfoModal.value.show({
      corpId: corp.corpId,
      interestYn: corp.interestYn,
    });
    corp.interestYn = result; // 관심기업여부 업데이트
  }

  onMounted(() => {
    retrieveList();
  });

  watch(user, (newUser) => {
    if (newUser) {
      userCorpId.value = newUser.userInfo?.corporation?.corpId || '';
      userCorpMasterYn.value = newUser.userInfo?.corpMasterYn || 'N';
      isStudent.value = newUser.userGb === 'STUDENT';
      if (newUser.userGb === 'COMPANY' && newUser.userInfo?.corpMasterYn === 'Y') {
        retrieveCorporation();
      } 
    }
  }, { immediate: true, deep: true });
</script>

<template>
  <div>
    <div class="process-wrap matching">
      <h4>기업 정보 등록 및 소개</h4>
      <div class="process-layout">
        <div class="process-steps-scroll">
          <ul>
            <li>- ‘기업정보’ 등록을 통해 기업을 소개하고 맞춤형 디스플레이 인재를 찾아보세요.</li>
            <li>- 기업정보는 채용공고와 연계되어 입사지원을 안정적으로 받을 수 있습니다.</li>
          </ul>
          <div class="process-steps">
            <div class="step"><div>기업정보<br>등록</div></div>
            <div class="step-arrow"><div></div></div>
            <div class="step"><div>기업정보<br>+채용공고연계<br>검색/제안</div></div>
            <div class="step-arrow"><div></div></div>
            <div class="step"><div>입사지원<br>확인</div></div>
            <div class="step-arrow"><div></div></div>
            <div class="step"><div>매칭 완료</div></div>
            <div class="step-arrow active"><div></div></div>
            <div class="step large active"><div>기업별<br>채용 전형 진행</div></div>
          </div>
        </div>
        <div class="button-with-info">
          <p>기업정보 등록 및 소개를 통해<br> 맞춤형 인재를 찾아보세요.</p>
          <div class="button-with-info-cta" @click="onClickEntryCorpInfo()">기업정보 등록하기<span class="icon-button-right"></span></div>
        </div>
      </div>
    </div>
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt>산업군</dt>
          <dd>
            <KSACheckBoxGroup
              ref="industryGbListRef"
              className="mr-md"
              name="industryGbs"
              v-model="searchInput.industryGbs"
              :options="industryGbOptions" />
          </dd>
        </dl>
        <dl>
          <dt>기업형태</dt>
          <dd>
            <KSACheckBoxGroup
              ref="corpGbListRef"
              className="mr-md"
              name="corpGbs"
              v-model="searchInput.corpGbs"
              :options="corpGbOptions" />
          </dd>
        </dl>
        <dl>
          <dt>상장여부</dt>
          <dd>
            <KSACheckBoxGroup
              ref="corpPublicYnListRef"
              className="mr-md"
              name="corpPublicYns"
              v-model="searchInput.corpPublicYns"
              :options="corpPublicYnOptions" />
          </dd>
        </dl>
        <dl>
          <dt>업종</dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.bizType" placeholder="업종을 입력해주세요." />
          </dd>
        </dl>
        <dl>
          <dt>사업장소재지</dt>
          <dd>
            <KSASelectResidenceArea
              class="select"
              ref="workAreaCorpRef"
              @selectOption1="onSelectedCorpArea1Option"
              @selectOption2="onSelectedCorpArea2Option"
            />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearch" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <div class="list-top">
      <p>기업정보 <span>{{ $number(totalCount)}}</span>개</p>
      <div class="grid">
        <KSASelect
          ref="searchOrderByRef"
          :options="jobOrderByList"
          class="select"
          @selectOption="onSelectOrderBy"
        />
        <KSASelect
          ref="searchPageSizeRef"
          :options="pageSizeGroup"
          class="select ml-xs"
          @selectOption="onSelectPageSize"
        />
      </div>
    </div>
    <div v-if="list.length > 0">
      <div class="corp-wrap">
        <dl v-for="corp in list" @click="onClickCorp(corp)">
          <dt>
            <KSAImage :src="corp.ciImgDir"/>
          </dt>
          <dd>
            <p class="text-over">{{ corp.corpName }}</p>
            <p class="text-over"><small>업종</small> {{ corp.bizType }}</p>
            <p class="text-over"><small>기업형태</small> {{ $gbNameKR('CORP_GB',corp.corpGb) }}</p>
            <p class="text-over"><small>상장여부</small> {{ corp.corpPublicYn === 'Y' ? '상장' : '비상장' }}</p>
            <div class="count">
              <p class="text-center">채용중인 공고 : <b>{{ corp.jobNoticeCnt || 0 }}</b></p>
            </div>
            <div v-if="isStudent">
              <KSATextButtonStop :text="corp.interestYn === 'Y' ? '♥' : '♡'" class="red_button" @click="onClickInterestCorp(corp)"/>
            </div>
          </dd>
        </dl>
      </div>
      <Paginate
        v-if="list.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="(pageNo) => onSelectPage(1, pageNo)"
      />
    </div>
    <div v-else class="lecture-none text-center">
      등록된 기업정보가 없습니다.
    </div>
  </div>
  <JobFairCorpInfoDetailModal ref="corpInfoModal"/> <!-- 기업정보 보기 -->
  <jobFairReusmeCreatePolicyModal ref="jobFairReusmeCreatePolicyModal" />
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
  
.corp-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 22px;
  dl {
    flex: 1 1 calc(25% - 22px);
    max-width: calc(25% - 16px);
    height: 254px;
    border: 1px solid $gray-regular_color;
    border-radius: 6px;
    padding: 16px;
    cursor: pointer;
    dt {
      width: 100%;
      height: 70px;
      border: 1px solid $gray-regular_color;
    }
    dd {
      position: relative;
      margin-top: 10px;
      .text-over {
        display: block;
      }
      h1 {
        font-size: 18px;
      }
      p {
        max-width: 100%;
        small {
          display: inline-block;
          width: 64px;
          font-size: 14px;
          color: $gray-color;
        }
        &.link {
          color: $blue_color;
        }
        &:first-child {
          max-width: calc(100% - 30px);
        }
        &:last-of-type {
          font-size: 14px;
        }
      }
      .count {
        border: 1px solid $blue_color;
        color: $blue_color;
        padding: 8px;
        border-radius: 8px;
        margin-top: 10px;
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
      }
    }
  }
}

.info-box {
  display: flex;
  background: $gray-light_color;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-block: 16px;
  padding: 16px;
}

.filter-wrap>.filter>dl>dd.majorGb {
  padding-right: 100px;
  display: flex;
  flex-wrap: wrap;
}

.lecture-none {
  height: 400px;
  line-height: 400px;
}
</style>